import { loadWidget } from '@sitevision/react';
import React from 'react';
import ReactDOM from 'react-dom';
import ProvisionsoverviewSection from './templates/molecules/provisionsoverview-section';

loadWidget('.plf-provisions-overview-area', provisionsOverviewWidget => {
    const action = provisionsOverviewWidget.dataset.action;
    ReactDOM.render(<ProvisionsoverviewSection action={action} />, provisionsOverviewWidget);
});
